import script from "./user-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./user-report-table.vue?vue&type=script&setup=true&lang=js"

import "./user-report-table.vue?vue&type=style&index=0&id=c7924816&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7924816"]])

export default __exports__